import Component from './Component';
import GlobalMessageComponent from './GlobalMessageComponent';
import ModalComponent from './ModalComponent';

export default class FavouriteComponent extends Component {

    get SELECTORS() {
        return {
            html: 'html',
            addFavouriteAuthor: '.js-add-favourite-author',
            addFavouriteArticle: '.js-add-favourite-article',
            header: 'header',
            login: 'loginModal',
            author: '.js-author',
            magArticle: '.js-magazine-article',
            body: 'body'
        }
    }

    get DATA() {
        return {
            dataCSRFToken: 'data-csrftoken',
            logged: 'data-logged',
            id: 'data-id',
            page: 'data-page'
        }
    }

    get CLASSES() {
        return {
            activeFavourite: 'add-favourite--active',
            isFavourite: 'is-favourite'
        }
    }

    get PAGES() {
        return {
            favouriteAuthors: 'favourite-authors',
            favouriteArticle: 'favourite-articles',
            search: 'PRODUCTSEARCH',
            category: 'CATEGORY'
        }
    }

    constructor() {
        super();
        this.token = this.getDataAttribute(this.SELECTORS.html, this.DATA.dataCSRFToken);
        this.GlobalMessageComponent = new GlobalMessageComponent();
        this.ModalComponent = new ModalComponent();
        this.isLogged = this.getDataAttribute(this.SELECTORS.header, this.DATA.logged) === 'true';
        this.page = this.getDataAttribute(this.SELECTORS.body, this.DATA.page);
    }

    getFavouriteAuthors() {
        if(this.isLogged && this.checkAuthors()) {
            fetch(this.endpoints.GET_FAVOURITE_AUTHOR.url, {
                method: 'get',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'CSRFToken': this.token, // This is set on request
                    'Cookie': this.token // This is missing from request
                }
            }).then((response) => response.json()).then((data) => {
                this.toggleHeartAuthor(data);  
            })
        }
    }

    getFavouriteArticles() {
        if(this.isLogged && this.checkArticles()) {
            fetch(this.endpoints.GET_FAVOURITE_ARTICLE.url, {
                method: 'get',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'CSRFToken': this.token, // This is set on request
                    'Cookie': this.token // This is missing from request
                }
            }).then((response) => response.json()).then((data) => {
                if(this.page === this.PAGES.CATEGORY || this.page === this.PAGES.search) this.removeHeartArticle();
                this.toggleHeartArticle(data);

                // Set the aria-label for all articles on load
                document.querySelectorAll(this.SELECTORS.magArticle).forEach(el => {
                  const favouriteButton = el.querySelector(this.SELECTORS.addFavouriteArticle);
                  if (favouriteButton) {
                      if (el.classList.contains(this.CLASSES.isFavourite)) {
                          favouriteButton.setAttribute('aria-label', 'Rimuovi dai preferiti');
                      } else {
                          favouriteButton.setAttribute('aria-label', 'Aggiungi ai preferiti');
                      }
                  }
              });
            })
        }
    }

    addFavouriteAuthor(id) {
        this.toggleLoader();
        fetch(this.endpoints.ADD_FAVOURITE_AUTHOR.url +'?authorCode=' + id, {
            method: 'post',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'CSRFToken': this.token, // This is set on request
                'Cookie': this.token // This is missing from request
            }
        }).then((response) => response.json()).then((data) => {
            this.toggleLoader();
            if (data.success && data.message === 'wishlist.add.ok') {
                this.toggleHeartAuthor([id]);
                this.GlobalMessageComponent.renderGlobalMessages('Autore aggiunto ai tuoi preferiti', 'info');
            }
            else if(data.message === 'wishlist.capacity.max') {
                this.GlobalMessageComponent.renderGlobalMessages('Hai raggiunto il numero massimo di autori nei tuoi preferiti', 'danger');
            }
            else {
                this.GlobalMessageComponent.renderGlobalMessages('Errore', 'danger');
            }
        })
    }

    addFavouriteArticle(id) {
        this.toggleLoader();
        fetch(this.endpoints.ADD_FAVOURITE_ARTICLE.url +'?articleLabel=' + id, {
            method: 'post',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'CSRFToken': this.token, // This is set on request
                'Cookie': this.token // This is missing from request
            }
        }).then((response) => response.json()).then((data) => {
            this.toggleLoader();
            if (data.success && data.message === 'wishlist.add.ok') {
                this.toggleHeartArticle([id]);
                this.GlobalMessageComponent.renderGlobalMessages('Articolo aggiunto ai tuoi preferiti', 'info');
            }
            else if(data.message === 'wishlist.capacity.max') {
                this.GlobalMessageComponent.renderGlobalMessages('Hai raggiunto il numero massimo di articoli nei tuoi preferiti', 'danger');
            }
            else {
                this.GlobalMessageComponent.renderGlobalMessages('Errore', 'danger');
            }
        })
    }

    removeFavouriteAuthor(id) {
        this.toggleLoader();
        fetch(this.endpoints.REMOVE_FAVOURITE_AUTHOR.url +'?authorCode=' + id, {
            method: 'post',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'CSRFToken': this.token, // This is set on request
                'Cookie': this.token // This is missing from request
            }
        }).then((response) => response.json()).then((data) => {
            this.toggleLoader();
             if (data.success && data.message === 'wishlist.remove.ok') {
                if(this.page === this.PAGES.favouriteAuthors) {
                    document.querySelector(this.SELECTORS.author + "[data-id='"+ id +"']").remove();
                }
                else {
                    this.toggleHeartAuthor([id]);
                }
                this.GlobalMessageComponent.renderGlobalMessages('Autore rimosso dai tuoi preferiti', 'info');
            }
            else {
                 this.GlobalMessageComponent.renderGlobalMessages('Errore', 'danger');
            }
         })
    }

    removeFavouriteArticle(id) {
        this.toggleLoader();
        fetch(this.endpoints.REMOVE_FAVOURITE_ARTICLE.url +'?articleLabel=' + id, {
            method: 'post',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'CSRFToken': this.token, // This is set on request
                'Cookie': this.token // This is missing from request
            }
        }).then((response) => response.json()).then((data) => {
            this.toggleLoader();
             if (data.success && data.message === 'wishlist.remove.ok') {
                if(this.page === this.PAGES.favouriteArticle) {
                    document.querySelector(this.SELECTORS.magArticle + "[data-id='"+ id +"']").remove();
                }
                else {
                    this.toggleHeartArticle([id]);
                }
                this.GlobalMessageComponent.renderGlobalMessages('Articolo rimosso dai tuoi preferiti', 'info');
            }
            else {
                 this.GlobalMessageComponent.renderGlobalMessages('Errore', 'danger');
            }
         })
    }

    toggleHeartAuthor(idS) {
        idS.forEach(id => {
            document.querySelectorAll(this.SELECTORS.author + "[data-id='"+ id +"']").forEach( el => {
                el.classList.toggle(this.CLASSES.isFavourite);
                el.querySelector(this.SELECTORS.addFavouriteAuthor).classList.toggle(this.CLASSES.activeFavourite);
            })
        })
    }

    removeHeartArticle() {
        document.querySelectorAll(this.SELECTORS.magArticles).forEach( el => {
            el.classList.remove(this.CLASSES.isFavourite);
            el.querySelector(this.SELECTORS.addFavouriteArticle).classList.remove(this.CLASSES.activeFavourite);
        });
    }

    toggleHeartArticle(idS) {
        idS.forEach(id => {
            document.querySelectorAll(this.SELECTORS.magArticle + "[data-id='"+ id +"']").forEach( el => {
                el.classList.toggle(this.CLASSES.isFavourite);
                const favouriteButton = el.querySelector(this.SELECTORS.addFavouriteArticle);
                favouriteButton.classList.toggle(this.CLASSES.activeFavourite);

                // Update aria-label based on the state of the favourite button
                if (favouriteButton.classList.contains(this.CLASSES.activeFavourite)) {
                    favouriteButton.setAttribute('aria-label', 'Rimuovi dai preferiti');
                } else {
                    favouriteButton.setAttribute('aria-label', 'Aggiungi ai preferiti');
                }
            })
        })
    }

    checkAuthors() {
        return document.querySelectorAll(this.SELECTORS.author).length > 0 ? true : false;
    }

    checkArticles() {
        return document.querySelectorAll(this.SELECTORS.magArticle).length > 0 ? true : false;
    }

    bindEvents() {
        this.events.on('click', this.SELECTORS.addFavouriteAuthor, (e) => {
            if(this.isLogged) {
                const author = e.target.closest(this.SELECTORS.author),
                    id = author.getAttribute(this.DATA.id);

                author.classList.contains(this.CLASSES.isFavourite) ? this.removeFavouriteAuthor(id) : this.addFavouriteAuthor(id);
            }
            else {
                this.ModalComponent.openModal(document.getElementById(this.SELECTORS.login));
            }
        });

        this.events.on('click', this.SELECTORS.addFavouriteArticle, (e) => {
            if(this.isLogged) {
                const article = e.target.closest(this.SELECTORS.magArticle),
                    id = article.getAttribute(this.DATA.id);

                article.classList.contains(this.CLASSES.isFavourite) ? this.removeFavouriteArticle(id) : this.addFavouriteArticle(id);
            }
            else {
                this.ModalComponent.openModal(document.getElementById(this.SELECTORS.login));
            }
        });
    }

    render() {
        this.log('render Favourite');
        this.bindEvents();
        this.getFavouriteAuthors();
        this.getFavouriteArticles();
    }
}